<template>
  <div>
    <div :id="mapId" class="map-canvas"></div>
  </div>
</template>

<script>
import initMapMixin from '../../../mixins/initMapMixin';

export default {
  mixins: [initMapMixin],
  props: {
    plots: {
      type: Array,
      require: true,
    },
  },

  watch: {
    async plots() {
      this.initMap();
      await this.addMarkers();
    },
  },

  methods: {
    mapLoaded() {
      this.addMarkers();
    },

    addMarkers() {
      this.plots.forEach((plot) => {
        let positionPlot = new this.google.maps.LatLng(plot.latitude, plot.longitude);

        new this.google.maps.Marker({
          position: positionPlot,
          draggable: true,
          map: this.map,
          animation: this.google.maps.Animation.DROP,
          title: plot.name,
        });
      });
    },
  },
};
</script>

<style scoped>
.map-canvas {
  height: 70vh;
}
</style>
